import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export const createCheckoutSession = async (userSession, purchaseDetails) => {
  console.log("userSession", userSession);
  try {
    const response = await api.post("/payment/create-checkout-session", {
      successUrl: `${window.location.origin}/payment-success`,
      cancelUrl: `${window.location.origin}/payment-cancel`,
      customerEmail: userSession?.user?.email,
      metadata: {
        userId: userSession?.user?.id,
      },
      customer_email: userSession?.user?.email,
      ...purchaseDetails,
    });

    if (response.status === 200) {
      const { url } = response.data;
      console.log(url);
      window.location.href = url;
    } else {
      if (response.status === 400) {
        throw new Error("Bad request: " + response.statusText);
      } else if (response.status === 500) {
        throw new Error("Internal server error: " + response.statusText);
      } else {
        throw new Error(
          "Failed to create checkout session: " + response.statusText
        );
      }
    }
  } catch (error) {
    console.error("Error creating checkout session:", error);
    throw error;
  }
};

export const verifyPayment = async (sessionId) => {
  try {
    const response = await api.post("/payment/verify-payment", { sessionId });
    return response.data; // This will include success, message, payment_status, etc.
  } catch (error) {
    console.error("Error verifying payment:", error);
    // Return a structured error response instead of throwing
    return {
      success: false,
      message: error.message || "Payment verification failed",
      payment_status: "failed",
    };
  }
};

export default {
  createCheckoutSession,
  verifyPayment,
};
